<style>
  .search-table-outter { overflow-x: scroll; }
 
  ::ng-deep .dropdown-item{color:black} 
  ::ng-deep .ngb-highlight{color:rgb(0, 26, 255)}
  
  </style>
  
  
  <div class="row">
    <div class="col-md-12">
      <h3 class="blueLabel">Enter Value of Work Done</h3>
    </div>
  </div>
  
  <hr style="margin: 0;border: lightgray solid 0.5px; ">
  <br />
  <div class="panel panel-primary">
    <div class="panel-heading">Employee Information</div>
    <div class="panel-body">
        <div class="form">
            <div class="form-group row">
                <label  class="col-sm-2 col-form-label">Name:</label>
                <div class="col-sm-2">
                  {{user.Name}}
                </div>
                <label  class="col-sm-2 col-form-label">Provisioning ID:</label>
                <div class="col-sm-2">
                    {{user.ProvisioningID}}
               </div>
               <label class="col-sm-2 col-form-label">Company Relationship Type:</label>
               <div class="col-sm-2">
                Employee
               </div>
            </div>
          <div class="form-group row">
             
              <label class="col-sm-2 col-form-label">Supervisor  :</label>
              <div class="col-sm-2">
                   {{user.Supervisor_Name}} 
              </div>
              <label class="col-sm-2 col-form-label">Job Title : </label>
              <div class="col-sm-2">
                  {{user.Position}}
              </div>
              <label class="col-sm-2 col-form-label">Department :</label>
              <div class="col-sm-2">
                  {{user.Department}}
              </div>
          </div>
          <div class="form-group row">
              <label class="col-sm-2 col-form-label">Work Location :</label>
              <div class="col-sm-2">
                  {{user.Work_Location}}
              </div>
              <label class="col-sm-2 col-form-label">Month/Year :</label>
              <div class="col-sm-2">
                  <select id="Monthlbl"  [(ngModel)]="Month" (change) ="getAllAccrual()" >
                      <option *ngFor="let _month of getMonths" [ngValue]="_month" >{{_month}}</option>
                    </select>&nbsp;
                    <select id="Year"  [(ngModel)]="Year" (change) ="getAllAccrual()" >
                      <option *ngFor="let _year of getYears" [ngValue]="_year" >{{_year}}</option>
                    </select>
              </div>
              <label class="col-sm-2 col-form-label">On Behalf Of : </label>
              <div class="col-sm-2">
              <select id="User" class="form-control" [(ngModel)]="SelectedUser" (change) ="getAllAccrual()" name="User">
                  <option value="" >Select</option>
                  <option *ngFor="let user of assignUsers" [ngValue]="user.CreatedBy"  >{{user.CreatedBy}} </option>
              </select>
              </div>
          </div>
          <div class="form-group row">
            <label class="col-sm-2 col-form-label">Provisioning ID : </label>
            <div class="col-sm-2">
            <select id="User" [disabled]="user.Role=='EndUser'" class="form-control" [(ngModel)]="SelectedProvisioningID" (change) ="getAllAccrual()" name="User">
              <option *ngFor="let user of viewUsers" [ngValue]="user.ProvisioningID"  >{{user.ProvisioningID}} </option>
               <option  value="ALL" >ALL</option>
          </select>
          </div>
        </div>
        </div>
    </div>
  
  </div>
  <div class="clearfix"></div>
  <br /> 
  
   
          <div class="col-md-4 ">
        <button class="btn btn-primary" (click)="Applyfilter()" >Apply Filter</button>&nbsp;
        <button class="btn btn-primary"  (click)="Clearfilter()" [disabled]="clearbutton==false">Clear Filter</button>&nbsp; 
      </div>       
      
    <br/>
    <br/>
    <br/>
  <div class="search-table-outter" >
    <table class="table table-bordered" >
      <thead>
        <tr>
          <th style="width:60px">Edit</th>
           <th style="width:60px" scope="col" > Select <input type="checkbox" [(ngModel)]="ChkAll" (change)="selectedAll(ChkAll)" /></th> 
          <th scope="col"   style="cursor: pointer;width:120px">Supplier AB# <tr> <td><input type="text"  id="SupplierABtxt" name="SupplierABtxt" [(ngModel)]="SupplierABtxtmodel" style="width:100px;color: black; " [ngbTypeahead]="searchSupplierAB" /></td></tr></th>
          
         
          <th style="width:120px;" scope="col">Supplier Name <tr> <td><input type="text" id="SupplierNametxt" name="SupplierNametxt" [(ngModel)]="SupplierNametxtmodel" style="width:100px;color: black;" [ngbTypeahead]="searchSupplierName" /></td></tr> </th>
          <th style="width:120px" scope="col" >Supplier Short Name <tr> <td><input type="text" id="Suppliershnametxt" name="Suppliershnametxt" [(ngModel)]="Suppliershnametxtmodel"  style="width:100px;color: black;"/></td></tr></th>
          <th style="width:120px" scope="col" >Object Account <tr> <td><input type="text" id="ObjAccounttxt" name="ObjAccounttxt" [(ngModel)]="ObjAccounttxtmodel" [ngbTypeahead]="searchObjectAcnt" style="width:100px;color: black;"/></td></tr></th>
          <th style="width:120px" scope="col" >Month/Year <tr> <td><input type="text" id="monthyeartxt" name="monthyeartxt" [(ngModel)]="monthyeartxtmodel" style="width:100px;color: black;"/></td></tr></th>
          <th style="width:120px" scope="col" >Cost Center <tr> <td><input type="text" id="Cstcentertxt" name="Cstcentertxt" [(ngModel)]="Cstcentertxtmodel" [ngbTypeahead]="searchCostcenter" style="width:100px;color: black;"/></td></tr></th>
          <th style="width:120px" scope="col" >Division Field <tr> <td><input type="text" id="Divisionfieldtxt" name="Divisionfieldtxt" [(ngModel)]="Divisionfieldtxtmodel" [ngbTypeahead]="searchDivisionField" style="width:100px;color: black;"/></td></tr></th>
          <th style="width:120px" scope="col" >Total VOWD Amount <tr> <td><input type="text" id="VoWDAmounttxt" name="VoWDAmounttxt" [(ngModel)]="VoWDAmounttxtmodel" style="width:100px;color: black;"/></td></tr></th>
          <th style="width:100px" scope="col" >Company Code <tr> <td><input type="text" id="Companycodetxt" name="Companycodetxt" [(ngModel)]="Companycodetxtmodel" style="width:80px;color: black;"/></td></tr></th>
          <th style="width:120px" scope="col" >Area <tr> <td><input type="text" id="Areatxt" name="Areatxt" [(ngModel)]="Areatxtmodel" [ngbTypeahead]="searchArea" style="width:100px;color: black;"/></td></tr></th>
          <th style="width:120px" scope="col" >Department <tr> <td><input type="text" id="Departmenttxt" name="Departmenttxt" [(ngModel)]="Departmenttxtmodel" [ngbTypeahead]="searchDepartment" style="width:100px;color: black;"/></td></tr></th>
          <th style="width:120px" scope="col" >Descr. Of Work <tr> <td><input type="text" id="Workdescriptiontxt" name="Workdescriptiontxt" [(ngModel)]="Workdescriptiontxtmodel" style="width:100px;color: black;"/></td></tr></th>
          <th style="width:120px" scope="col" >ContractID <tr> <td><input type="text" id="ContractIDtxt" name="ContractIDtxt" [(ngModel)]="ContractIdModel" style="width:100px;color: black;"/></td></tr></th>
          <th style="width:120px" scope="col" >Contract Amount <tr> <td><input type="text" id="ContractIDAmounttxt" name="ContracIDtAmounttxt"  style="width:100px;color: black;"/></td></tr></th>
          <th style="width:120px" scope="col" >Submitted <tr> <td><input type="text" id="Submitttedtxt" name="Submitttedtxt" [(ngModel)]="Submitttedtxtmodel" style="width:100px;color: black;"/></td></tr></th>
          <th style="width:100px" scope="col" >Created By <tr> <td><input type="text" id="createdBytxt" name="createdBytxt" [(ngModel)]="createdBytxtmodel" [ngbTypeahead]="searchUsers" style="width:80px;color: black;"/></td></tr></th>
          </tr>
        
             <tr *ngFor="let accrual of lstAccruals |  grdSearch: {SupplierAB: searchText,SupName:searchText,SupShortName:searchText,ObjectAccount:searchText,ObjDescr:searchText,Period:searchText,CostCenter:searchText,DivisionField:searchText,VOWDAmount:searchText,DescrOfWork:searchText,Submitted:searchText,CreatedBy:searchText,CCcode:searchText} | paginate: { itemsPerPage: 10, currentPage: p} ">
              <td> <button type="button" class="btn btn-primary" (click)="openVowdModal(accrual)" [disabled]="user.Role=='EndUser' && accrual.Submitted=='Submitted' ">
                      <span class="glyphicon glyphicon-edit" ></span>
                  </button>
             </td>
           
            <td><input type="checkbox" [(ngModel)]="accrual.selected" [disabled]="user.Role=='EndUser' && accrual.Submitted=='Submitted'"  ></td> 
             <td title="Supplier AB#">{{ accrual.SupplierAB }}</td>
             <td title="Supplier Name">{{ accrual.SupName }}</td>
             <td title="Supplier Short Name" style="word-wrap: break-word;">{{ accrual.SupShortName }}</td>  
          
             <td title="Object Account">{{ accrual.ObjDescr }}</td>
             <td title="Month/Year">{{ accrual.Period }}</td>
             <td title="Cost Center">{{ accrual.CostCenter }}</td>
             <td title="Division Field">{{ accrual.DivisionField }}</td>
             <td title="Total VOWD Amount">{{ accrual.TotalVOWDAmount | currency:'':''}} {{accrual.CurrencyType }}</td>
             <td title="Company Code">{{ accrual.MstCostCenter.CompanyCode }}</td>
             <td title="Area">{{ accrual.MstCostCenter.Area_CODE}}-{{ accrual.MstCostCenter.Area_description }}</td>
             <td title="Department">{{ accrual.MstCostCenter.Division }}</td>
             <td title="Descr. of work">{{ accrual.DescrOfWork }}</td>
             <td title="Contract">{{ accrual.ContractId }}-{{ accrual.ContractDecscription }}</td>
             <td title="Contract Amount">{{ accrual.ContractAmount | currency:'':''}} {{accrual.CurrencyType }}</td>
             <td title="Submitted">{{ accrual.Submitted}}</td>
             <td title="Created By">{{ accrual.CreatedBy|uppercase}}</td>
             
        </tr>
      </thead>
      <tbody>
    
      </tbody>
    </table>
  
    <pagination-controls (pageChange)="p = $event"></pagination-controls> 
  </div>
  <br><br>
  <div class="row col-md-12" >
    <div class="col-md-4 ">
      <button class="btn btn-primary" (click)="openVowdModal(null)" [disabled]="user.Role=='ReadOnly'">Add New</button>&nbsp;
      <button class="btn btn-primary" (click)="deleteAll()" [disabled]="user.Role=='ReadOnly'">Delete all selected record</button>&nbsp;
     
    </div>
    <div class="col-md-4"></div>
    <div class="col-md-4 ">
        <button class="btn btn-primary" (click)="convertToUSD()" [disabled]="user.Role=='ReadOnly'">Convert to USD</button>&nbsp;
        <button class="btn btn-primary" (click)="submit()" [disabled]="!flgSubmit" [disabled]="user.Role=='ReadOnly'">Submit</button>
      </div>
    </div>
    <div  id="collapseExample">
        <div class="card card-body">
            <br/>
            <br/>
            <br/>
            <app-excel-upload (onUpload)="Upload($event)"></app-excel-upload>
        </div>
    </div>
  
  
  
  
  
    
  